import { WindowEvent } from "../windowEvent.service";

type HeaderButtonActivatedEventDetail = undefined;

export class HeaderButtonActivatedEvent extends CustomEvent<HeaderButtonActivatedEventDetail> {
    constructor() {
        super(WindowEvent.HeaderButtonActivated);
    }
}
